import { Grid, Typography } from "@material-ui/core";
import { formatNumberToMonetary } from "../../../utils";
import { IInstallment } from "api/interfaces";
import MaskedField from "../../UI/Fields/MaskedField";

import { lang } from "../../../i18nLang";

interface IProps {
  installments: IInstallment[];
  total: number;
  onChange: Function;
  hasTotalDiff: boolean;
  diffErrorLabel: string;
}

const InstallmentsFields = ({
  installments,
  total = 0,
  onChange,
  hasTotalDiff,
  diffErrorLabel,
}: IProps) => {
  const totalFormated = formatNumberToMonetary(total);

  const handleChangeInputInstallment = (index) => (ev) => {
    const { value } = ev.target;
    const newArray: any = [...installments];
    newArray[index].value = value;
    onChange(newArray);
  };

  return installments.length > 1 || hasTotalDiff ? (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Typography
          color={hasTotalDiff ? "error" : undefined}
          style={{ marginTop: "1rem", fontWeight: 500 }}
        >
          {`${lang("fields.totalValue").toUpperCase()}: ${totalFormated}`}
        </Typography>
        {hasTotalDiff && (
          <Typography variant="caption" color="error">
            {diffErrorLabel}
          </Typography>
        )}
      </Grid>
      {installments.map((inst: any, index) => (
        <Grid item xs={4} key={inst.id} style={{ marginTop: "0.5rem" }}>
          <MaskedField
            name={`installment-${inst.id}`}
            label={lang("fields.installmentNumber", inst.id)}
            fullWidth
            prefix={`${lang("currency")} `}
            fixedDecimalScale
            value={inst.value}
            onChange={handleChangeInputInstallment(index)}
            disabled={Boolean(inst.measurementId)}
            align={"right"}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
      ))}
    </Grid>
  ) : (
    <></>
  );
};

export default InstallmentsFields;
